module.exports = __webpack_public_path__ + "resources/img/img_watchall_sms1_m.5842f6e0500f6337fdb12593054afb8a.png";